window.VAE = window.VAE || {};

VAE.Config = (function () {
  'use strict';

  const FRIENDLY_CAPTCHA_SITE_KEY = 'FCMN8RVBCS76TLJ3';
  const SUPABASE_URL = 'https://auth.accessibleai.eu/functions/v1';

  const settings = {
    isOpen: true,
    activeTab: 'auto',
  };

  const api = {
    endpoint: `${SUPABASE_URL}/wcag-task-manager`,
    betaEndpoint: `${SUPABASE_URL}/wcag-task-manager-beta`,
    reportProblemEndpoint: `${SUPABASE_URL}/report-problem`,
    includeScreenshots: false,
    timeout: 120000,
  };

  const client = {
    autoAnalyze: true,        // 🔥 DEAKTIVIERT für Testing - Controls whether widget automatically starts analysis on initialization
                              // Set to false to require manual "Analyse starten" button click
    autoApplyFixes: false,
    autoSubmitFixes: false,   // DEPRECATED: Use autoAnalyze instead for controlling automatic analysis
    useSSE: true,
    showFailedCorrections: true,
    friendlyCaptchaSiteKey: FRIENDLY_CAPTCHA_SITE_KEY,
    // T-006.1.3: Feature-Flag für konsolidierte Analyse
    enableConsolidatedAnalysis: true,  // Enable consolidated analysis with 95% cost reduction
    consolidatedAnalysisFallback: false, // Enable automatic fallback to legacy mode if consolidated fails
  };

  // US-001: Strategy configuration for smart content-size analysis
  const strategy = {
    // Size thresholds for automatic strategy selection
    maxConsolidatedSizeKB: 100,       // Switch to chunking if HTML > 100KB
    maxConsolidatedTokens: 120000,    // Switch to chunking if estimated tokens > 120K
    
    // Feature flags for strategy control
    enableAutoStrategy: true,         // Enable automatic strategy selection based on content size
    enableChunking: true,             // Enable chunking strategy (fallback to legacy if disabled)
    
    // Fallback behavior configuration
    fallbackToLegacy: true,           // Enable fallback to legacy mode if chunking fails
    maxRetryAttempts: 2,              // Maximum retry attempts before giving up
    
    // Performance settings
    tokenEstimationTimeout: 50,       // Max time (ms) for token estimation
    
    // Override settings (for debugging/testing)
    forceStrategy: null,              // Force specific strategy: 'consolidated' | 'chunking' | 'legacy' | null
    logStrategyDecisions: true        // Enable detailed logging of strategy decisions
  };

  function getTokenFromScriptTag() {
    try {
      // Find the widget script by looking for scripts with vae.min.js or vae.js in the src
      const scripts = document.querySelectorAll('script[src*="vae.min.js"], script[src*="vae.js"]');
      const widgetScript = scripts[scripts.length - 1]; // Get the last matching script
      
      if (widgetScript) {
        const token = widgetScript.getAttribute('data-token') || 
                     widgetScript.getAttribute('data-api-token');
        if (token) {
          console.log('VAE.Config: Found token in script tag data attribute');
          return token;
        }
      }
      
      // Fallback to currentScript if available
      if (document.currentScript) {
        const token = document.currentScript.getAttribute('data-token') ||
                     document.currentScript.getAttribute('data-api-token');
        if (token) {
          console.log('VAE.Config: Found token in currentScript data attribute');
          return token;
        }
      }
      
      return null;
    } catch (error) {
      console.warn('VAE.Config: Error reading token from script tag:', error);
      return null;
    }
  }

  function resolveToken() {
    // Priority 1: window.vaeConfig (current method, highest priority)
    if (window.vaeConfig?.token) {
      console.log('VAE.Config: Using token from window.vaeConfig');
      return window.vaeConfig.token;
    }
    
    // Priority 2: Script tag data attribute (new method, fallback)
    const scriptToken = getTokenFromScriptTag();
    if (scriptToken) {
      return scriptToken;
    }
    
    console.warn('VAE.Config: No token found in window.vaeConfig or script tag attributes');
    return null;
  }

  const config = {
    client: {
      ...client,
      token: resolveToken(),
      ...window.vaeConfig  // Still allow full config override, including token override
    },
    api,
    settings,
    strategy: {
      ...strategy,
      ...window.vaeConfig?.strategy  // Allow strategy config override via window.vaeConfig
    },
  };

  return config;
})();

console.log('VAE: Config-Modul initialisiert', { VAE });
